import { ApiEndPoints, NetworkManager } from "../network";

export class UsersService {
  static getAllUsers = (page = 1, limit = 10, pages = 1) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.users,
      params: { page, pages, limit },
    });
  };

  static addUsers = (user) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.addUsers,
      data: {
        ...user,
      },
    });
  };

  static geUsersById = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.users + "/" + id,
      data: { ...id },
    });
  };

  static updateUsers = (user) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.updateUsers,
      data: { ...user },
    });
  };

  static deleteUsers = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "delete",
      url: ApiEndPoints.users + "/" + id,
      data: { ...id },
    });
  };

  static verifyUserEmail = (emailId) => {
    return NetworkManager.getInstance().appRequest({ 
      method: "get", 
      url: `${ApiEndPoints.users}/verify-email?emailId=${encodeURIComponent(emailId)}` 
    });
  };

  static updateUsersPassword = (user) => {
    return NetworkManager.getInstance().appRequest({ 
      method: "put", 
      url: ApiEndPoints.users + "/password", 
      data: { ...user } });
  };
}
